const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

const activeCode = r =>
  require.ensure(
    [],
    () => r(require('@/modules/hybird/activeCode.vue')),
    'personCenter'
  )

const hybird = [
  {
    path: '/hybird',
    name: 'hybird',
    redirect: '/hybird/activeCode',
    component: Layout,
    meta: {
      auth: false,
      breadcrumbShow: true,
      id: '48fdaaa0fdf547e8af1300d3408c100a'
    },
    children: [
      {
        path: '/hybird/activeCode',
        name: 'activeCode',
        component: activeCode,
        meta: {
          id: '48fdaaa0fdf547e8af1300d3408c100a',
          breadcrumbShow: false,
          auth: true
        }
      }]
  }]

export default hybird



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/hybird.js